import clsx from 'clsx';
import { getAlphabetLetter } from '../../utils/functions';
import { CircleIcon, CubicIcon, PolygonIcon, StarIcon, TriangleIcon, XIcon } from '../Icons';
import classes from './LetterContainer.module.scss'

const ICON_TYPE = {
    0: CircleIcon,
    1: CubicIcon,
    2: TriangleIcon,
    3: XIcon,
    4: PolygonIcon,
    5: StarIcon
}
export default function LetterContainer(props) {

    const { index } = props;
    const IconType = ICON_TYPE[index] ?? null;

    return (
        <div className={clsx(classes.letterContainer, classes[`position-${index}`])}>
            <IconType />
            <div className={classes.letter}>{getAlphabetLetter(index)}</div>
        </div>
    );
}